module.exports = "/_next/static/images/OgSecurity-b5b17d4f64260275feecee885fe0296f.png";